<template>
    <div class="container-barx">
        <v-chart :options="option"  autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'zrender/lib/svg/svg'



export default {
  name: 'barChartX',
  props: {  
     rotate:{
       type:Number,
       default:40
     },
     radius:{
       type:Array,
       default:()=>{
          return [0,5,5,0]
       }
     },
     data:{
       type:Object,
       default:()=>{
         return {
           y: ['广州K11店', '广州北京路225店', '重庆西城天街', '西安熙地港', '深圳光明大仟里', '南京弘阳广场', '广州花都融创中心'],
           value: [1200, 1200, 1200, 999, 888, 1111, 1111]
         }
       }
     }
  },
  data () {  
    return {     
       option:{}
    }
  },
  methods: {
 
  },
  mounted () {
    this.option = {
  
        grid: {
            top:'10%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
                axisLabel: {             
                  rotate:this.rotate,
                color:'#FFFFFF',                
                  formatter: function(value,index){
                    var value;
                    
                    if (value >=1000) {
                      value = value/1000+'k';
                    }else if(value <1000){
                      value = value;
                    }
                    return value
                  }     
               },
             type: 'value',
              splitLine:{ 
                 lineStyle:{
                     color: ['#292C38']
                 }
              }
            
        },
        yAxis: {
            axisLabel: {             
                color:'#FFFFFF'
             },
            axisTick:{show:false},
            type: 'category',
            
            data: this.data.y
        },
       
        series: [
           {
              
                type: 'bar',                     
                data: this.data.value,
                itemStyle:{
                  normal:{
                   
                    barBorderRadius:this.radius,
                      color: function(params){
                          var c ='';
                          
                          if(params.dataIndex==3){
                              c='#F7517F'
                          }else{
                              c='#377DFF'
                          }
                          return c;
                      }
                    },                  
                },
              barWidth:10       
            }             
                
        ]
    };
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-barx{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>